

























































































































































































































import { Component, Emit, Vue } from 'vue-property-decorator'
import { Factories } from '@finx/web-repository'
import DadosCadastraisStore from '@finx/web-repository/src/stores/DadosCobranca'
import PagamentoStore from '@finx/web-repository/src/stores/Pagamento'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'

const component: Object = {
  store: {
    DadosCadastraisStore,
    PagamentoStore,
  },
}

@Component(component)

export default class ComponentFormEndereco extends Vue {
  stores: any = {
    dadosCobranca: (this.$store as any).DadosCadastraisStore,
    pagamento: (this.$store as any).PagamentoStore,
  }

  alert: any = {
    show: false,
    message: '',
  }

  formIsValid: Boolean = false
  Messages: any = Factories.Messages
  Validator: any = Factories.Validator

  get dadosCobranca() {
    return this.stores.dadosCobranca.getters.DADOS_COBRANCA
  }

  get loading() {
    return this.stores.pagamento.getters.LOADING
  }

  mounted() {
    this.getDadosCobranca()
  }

  async getDadosCobranca() {
    const request = await ApiLegacy.DadosCobranca.getDadosCobranca()

    if (request.status === 200) {
      const dadosCobranca = request.data

      if (dadosCobranca.endereco) {
        this.stores.dadosCobranca.commit('DADOS_COBRANCA', dadosCobranca)
      }
    }
  }

  @Emit('submit')
  submit() {}

  async updateDadosCobranca() {
    const dadosCobranca = this.trimAddress(this.dadosCobranca)

    const request = await ApiLegacy.DadosCobranca.updateDadosCobranca(this.dadosCobranca)
    const success = request.status === 200

    if (success) this.submit()
    else {
      this.alert.show = true
      this.alert.message = 'Erro. Tente novamente mais tarde'

      this.stores.pagamento.commit('LOADING', false)
    }
  }

  trimAddress(dados: any) {
    const dadosCobranca = dados
    dadosCobranca.endereco.cidade = dadosCobranca.endereco.cidade.trim()

    return dadosCobranca
  }

  validate() {
    const form = (this.$refs as any).formEndereco

    if (form.validate()) {
      this.stores.pagamento.commit('LOADING', true)

      this.updateDadosCobranca()
    }
  }
}
